import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const AgentCallService = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();

  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [farmerNumber, setFarmerNumber] = useState("");

  const [farmerData, setFarmerData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getFarmerEnrollmentTemplateData } = useHttp();

  const fillFarmerEnrollmentTemplateData = (employeeId, regionId, farmerNo) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }
    if (
      stateName &&
      typeof stateName === "string" &&
      stateName.trim().length > 0
    ) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/agentCallServiceDetailreport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getFarmerEnrollmentTemplateData(
      {
        url: url,
      },
      (data) => {
        //   console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillFarmerEnrollmentTemplateData(0, 0, "");
  }, [getFarmerEnrollmentTemplateData]);

  const fieldsToExport = [
    "farmerNo",
    "createdDate",
    "farmerName",
    "plotSizeInHa",
    "mobile",
    "agentName",
    "fieldExecutiveName",
    "outstandingLoan",
    "clientReachedUnreached",
    "response",
    "paidAmount",
    "balanceAmount",
    "createdDate",
  ];

  const customHeaders = [
    "Farmer No",
    "Enrollment Date",
    "Farmer Name",
    "Plot Size(Ha)",
    "Phone Mobile",
    "Agent Name",
    "Field Executive Name",
    "Outstanding Loan Amount",
    "Reached/Unreached",
    "Response",
    "Paid Amount",
    "Balance Amount",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "FarmerInspectionReport.xlsx";
    //console.log(fieldsToExport, customHeaders);

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log("state", data);

        setStatedata(data);
      }
    );
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        // console.log("farmerNumberList", data);

        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Agent Call Service</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillFarmerEnrollmentTemplateData(
                        employeeId,
                        regionId,
                        farmerNumber
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Farmer No</th>
                          <th>Enrollment Date</th>
                          <th>Farmer Name</th>
                          <th>Plot Size(Ha)</th>
                          <th>Phone Mobile</th>
                          <th>Agent Name</th>
                          <th>Field Executive Name</th>
                          <th>Outstanding Loan Amount</th>
                          <th>Reached/Unreached</th>
                          <th>Response</th>
                          <th>Paid Amount</th>
                          <th>Balance Amount</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerNo}</td>
                                <td>{itm.createdDate}</td>
                                <td>{itm.farmerName}</td>
                                <td>{itm.plotSizeInHa}</td>
                                <td>{itm.mobile}</td>
                                <td>{itm.agentName}</td>
                                <td>{itm.fieldExecutiveName}</td>
                                <td>{itm.outstandingLoan}</td>
                                <td>{itm.clientReachedUnreached}</td>
                                <td>{itm.response}</td>
                                <td>{itm.paidAmount}</td>
                                <td>{itm.balanceAmount}</td>
                                <td>{itm.createdDate}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgentCallService;
